import {
  CellType,
  ComponentType,
  EmptyObject,
  GridComponentType,
  IMediaListModel,
  Orientation,
} from "@nf/common";
import React from "react";
import dynamic from "next/dynamic";

const GridComponent = dynamic(
  () =>
    import("components/Configuration/ListComponent/components/GridComponent")
);

export type TPlayListGridGrid = {
  mediaList: IMediaListModel | EmptyObject;
  cellType: CellType;
};

export const PlayListGrid: React.FC<TPlayListGridGrid> = ({
  mediaList,
  cellType,
}) => {
  const cellCount = cellType === CellType.Cover || CellType.CoverLarge ? 6 : 3;
  return (
    <GridComponent
      gridComponentType={GridComponentType.GenresScreen}
      dynamicHeight
      columns={cellCount}
      rows={mediaList?.Entities ? mediaList?.Entities?.length : 0}
      component={{
        ComponentTypeCode: ComponentType.List,
        CellType: cellType,
        Orientation: Orientation.Grid,
        MediaList: mediaList?.Entities,
      }}
    />
  );
};

export default PlayListGrid;
